export const harvard_valid_email_extensions = [
    'harvard.edu',
    'college.harvard.edu',
    'fas.harvard.edu',
    'g.harvard.edu',
    'hks.harvard.edu',
    'hsph.harvard.edu',
    'gse.harvard.edu',
    'gsd.harvard.edu',
    'hbs.edu',
    'hms.harvard.edu',
    'law.harvard.edu', 
    'extension.harvard.edu',

    // Add more emails extensions here
];